import React, { useEffect, useState } from "react";
import "./VideoModal.css";

const VideoModal = ({ isOpen, onClose }) => {
  const [videoSrc, setVideoSrc] = useState("");

  useEffect(() => {
    if (isOpen) {
      // Set video URL when modal opens
      setVideoSrc("https://www.youtube.com/embed/lQE5GLeSrhQ");
    } else {
      // Clear video URL when modal closes to stop playback
      setVideoSrc("");
    }
  }, [isOpen]);
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Founder Intro</h2>
          <button className="close-btn" onClick={onClose}>
            &#10005;
          </button>
        </div>
        <div className="modal-body">
          <iframe
            title="video"
            src={videoSrc}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            className="video-player"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
